import React from 'react';
import { Link as RouterLink, LinkProps } from 'react-router-dom';
import { styled } from '@quillbot/design-system';

interface LinkParams extends Omit<LinkProps, 'to'> {
  href?: Href | string;
  to?: string;
  target?: string;
}

type Href = {
  pathname: string;
  query?: { [key: string]: string };
};

const StyledAnchor: any = styled('a')`
  text-decoration: none;
`;

const StyledRouterLink = styled(RouterLink)`
  text-decoration: none;
`;

function isAbsoluteUrl(href: Href | string | undefined) {
  const pat = /^https?:\/\//i;
  return typeof href === 'string' && pat.test(href);
}

export default function Link(props: LinkParams) {
  function createLink(pathname: string, queryString = '') {
    const { children, ...rest } = props;
    if (isAbsoluteUrl(href)) {
      return (
        <StyledAnchor href={pathname} {...rest}>
          {children}
        </StyledAnchor>
      );
    } else {
      return (
        <StyledRouterLink to={`${pathname}${queryString}`} {...rest}>
          {children}
        </StyledRouterLink>
      );
    }
  }

  function createQueryString(query?: { [key: string]: string }) {
    return query
      ? `?${Object.keys(query)
          .map((key) => `${key}=${query[key]}`)
          .join('&')}`
      : '';
  }

  const { href, to } = props;
  if (typeof href === 'string') {
    return createLink(href);
  } else if (typeof to === 'string') {
    return createLink(to);
  } else {
    const { pathname, query } = href as Href;
    const queryString = createQueryString(query);
    return createLink(pathname, queryString);
  }
}
